module.exports = __webpack_public_path__ + "static/media/filter_icon_transparent.70c4468b.png";